acom_app.models.Helper = acom_app.BaseNestedModel.extend({
    defaults: {
        base: {},
        post_types: {},
        default_pages: {},
        pages: {},
        categories: {},
        menus: {},
        fonts: {},
        plugin: {}
    }
})